import { IConfigurationItem, IConfigurationSection } from "../../configuration";
import { IConfigurationStyles, useConfigurationStyles } from "../../layouts";
import { ConfigurationItem } from "./configurationItem";

export interface ConfigurationSectionProps extends IConfigurationSection {
    controlStyles?: IConfigurationStyles | undefined;
    showTitle?: boolean | undefined
}

export const ConfigurationSection: React.FC<ConfigurationSectionProps> = (props) => {
    const styles: IConfigurationStyles = props.controlStyles ?? useConfigurationStyles();

    return (
        <>
            {(props.isDisplayed || props.isDisplayed === undefined) && (
                <div className="mb-5">
                    <div className="card-body">
                        {props.showTitle === undefined || props.showTitle === true &&
                            <h3 style={styles.sectionTitle} className="border-bottom mb-3 pb-2" >
                                {props.title}
                            </h3>
                        }
                        {props.subtitle && (
                            <p style={styles.sectionSubtitle} className="mb-2">
                                {props.subtitle}
                            </p>
                        )}
                        <div className="row gx-5">
                            {props.items.filter(function (x) { return x.isDisplayed || x.isDisplayed === undefined }).map((item: IConfigurationItem, index: number) => (
                                <div className="col-12  col-xl-6  py-2" key={index}>
                                    <ConfigurationItem {...item} controlStyles={styles} />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};